import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">CoKilo</h3>
            <p className="text-gray-400">
              La plateforme de partage de bagages entre voyageurs et expéditeurs.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Légal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/cgu" className="text-gray-400 hover:text-white">
                  Conditions Générales
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white">
                  Politique de Confidentialité
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white">
                  Nous contacter
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Télécharger l'app</h4>
            <p className="text-gray-400 mb-4">Bientôt disponible sur</p>
  <div className="space-y-3">
    <a href="#" className="block items-center">
      <img 
        src="https://play.google.com/intl/en_us/badges/static/images/badges/fr_badge_web_generic.png" 
        alt="Disponible sur Google Play" 
        className="h-[48px]"
      />
    </a>
    <a href="#" className="block items-center">
      <img 
        src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/white/fr-fr?size=250x83" 
        alt="Télécharger sur l'App Store" 
        className="h-10"
      />
    </a>
    
  </div>
            
              
           
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2025 CoKilo. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};